import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, of } from 'rxjs';
import { AppVersionInterface } from '../models/app-version.interface';
import { Environment } from './environment.service';
import { shareReplay } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class BuildInfoService {
  public readonly version$: Observable<AppVersionInterface | null>;
  private readonly API_NAME: string = 'buildInfo';

  constructor(
    private apiService: ApiService,
    private environment: Environment
  ) {
    this.version$ = this.environment.production
      ? of(null) // prod: no request, nothing to show
      : this.getVersion().pipe(shareReplay(1));
  }

  // Get build version details
  public getVersion(): Observable<AppVersionInterface> {
    return this.apiService.get(this.API_NAME, `version`, null);
  }
}
